// extracted by mini-css-extract-plugin
export var actionButton = "_7r-0";
export var attachmentLine = "_7r-1";
export var fileInput = "_7r-2";
export var fileUploadWrapper = "_7r-4";
export var footer = "_7r-3";
export var modalContent = "_7r-5";
export var paperclip = "_7r-6";
export var quillEditor = "_7r-7";